import type {
  IBatchedStrokesRquest,
  ILocalListPayload,
  IStrokesToAdd,
} from 'comps/learnosity/v1/question-polypad/usePubNubRemoteSync';

import { ACTIONS } from 'actions/math-canvas-sync';

export interface IMathCanvasReducer {
  recievedLocalStrokesStore: {
    [key: string]: ILocalListPayload;
  };
  requestedStrokesData: {
    [key: string]: IBatchedStrokesRquest;
  };
  strokeDataToAdd: {
    [ket: string]: IStrokesToAdd;
  };
}

const initialState: IMathCanvasReducer = {
  recievedLocalStrokesStore: {},
  requestedStrokesData: {},
  strokeDataToAdd: {},
};

interface ActionType {
  type: string;
  eventData: {
    payload: ILocalListPayload | IBatchedStrokesRquest | IStrokesToAdd;
    eventType: string;
  };
}

export default function mathCanvasSyncReducer(
  state: IMathCanvasReducer = initialState,
  action: ActionType,
) {
  const { type, eventData } = action;

  switch (type) {
    case ACTIONS.SAVE_LOCAL_STROKES_FROM_PEER: {
      const { payload } = eventData;
      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      return {
        ...state,
        recievedLocalStrokesStore: {
          ...state.recievedLocalStrokesStore,
          [key]: payload,
        },
      };
    }
    case ACTIONS.REMOVE_LOCAL_STROKES_FROM_PEER: {
      const { payload } = eventData;

      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      return {
        ...state,
        recievedLocalStrokesStore: {
          ...state.recievedLocalStrokesStore,
          [key]: null,
        },
      };
    }
    case ACTIONS.STORE_REQUEST_STROKE_DATA: {
      const { payload } = eventData;
      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      return {
        ...state,
        requestedStrokesData: {
          ...state.requestedStrokesData,
          [key]: { ...payload },
        },
      };
    }

    case ACTIONS.REMOVE_REQUEST_STROKE_DATA: {
      const { payload } = eventData;
      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      return {
        ...state,
        requestedStrokesData: {
          ...state.requestedStrokesData,
          [key]: null,
        },
      };
    }

    case ACTIONS.STORE_BATCHED_STROKES_TO_ADD: {
      const { payload } = eventData as { payload: IStrokesToAdd };
      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      const strokeData = state.strokeDataToAdd[key];
      let strokesDataToStore = strokeData ? Object.create(strokeData) : null;

      if (strokesDataToStore) {
        Object.keys(payload.strokes).map(strokeId => {
          strokesDataToStore.strokes[strokeId] = payload.strokes[strokeId];
        });
      } else {
        strokesDataToStore = payload;
      }

      return {
        ...state,
        strokeDataToAdd: {
          ...state.strokeDataToAdd,
          [key]: strokesDataToStore,
        },
      };
    }
    case ACTIONS.REMOVE_ADDED_BATCHED_STROKES: {
      const { payload } = eventData as { payload: IStrokesToAdd };
      const { attemptId, questionResponseId } = payload;
      const key = `${attemptId}_${questionResponseId}`;

      const strokeData = state.strokeDataToAdd[key];
      const currentStrokeData = strokeData ? Object.create(strokeData) : null;

      const newStrokeData: IStrokesToAdd = { ...payload, strokes: {} };

      if (currentStrokeData) {
        Object.keys(currentStrokeData.strokes).map(strokeId => {
          if (!payload.strokes[strokeId]) {
            newStrokeData.strokes[strokeId] = currentStrokeData.strokes;
          }
        });
      }

      return {
        ...state,
        strokeDataToAdd: {
          ...state.strokeDataToAdd,
          [key]: Object.keys(newStrokeData.strokes).length ? newStrokeData : null,
        },
      };
    }
    default:
      return state;
  }
}
